export default "__VITE_ASSET__49c8e0b5__"